import { X, Check } from 'lucide-react';
import { FadeIn } from '@/components/ui/fade-in';

export default function ProblemSolution() {
  const problems = [
    'Email delays (5-30 minutes)',
    'Spam filters block notifications',
    'Checking multiple inboxes',
    'Missed opportunities',
  ];

  const solutions = [
    'Instant delivery (<1 second)',
    'Always reaches you',
    'One app you already use',
    'Never miss a lead',
  ];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
          Email Notifications Are Broken
        </h2>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {/* Problems */}
          <FadeIn delay={0.1}>
            <div className="bg-red-50 border border-red-200 rounded-lg p-8">
              <h3 className="text-xl font-semibold text-red-900 mb-6">The Problem</h3>
              <ul className="space-y-4">
                {problems.map((problem, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                    <span className="text-gray-700">{problem}</span>
                  </li>
                ))}
              </ul>
            </div>
          </FadeIn>

          {/* Solutions */}
          <FadeIn delay={0.2}>
            <div className="bg-green-50 border border-green-200 rounded-lg p-8">
              <h3 className="text-xl font-semibold text-green-900 mb-6">The Solution</h3>
              <ul className="space-y-4">
                {solutions.map((solution, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                    <span className="text-gray-700">{solution}</span>
                  </li>
                ))}
              </ul>
            </div>
          </FadeIn>
        </div>

        <p className="text-center text-lg text-gray-600 mt-8 max-w-2xl mx-auto">
          Your customers don't wait. Neither should you.
          <br />
          Get form submissions in Telegram where you actually check messages.
        </p>
      </div>
    </section>
  );
}
